import { Plus } from 'lucide-react'
import React from 'react';
import './addbutton.css';

const AddDynamicButton = ({ title, onClick, logo }) => {
    return (
        <button
            title={title}
            className="btn-animated"
            onClick={onClick}
        >
            <div className="btn-content">
                {logo}
                <span>{title}</span>
            </div>
            <div className="btn-ripple"></div>
        </button>
    )
}

const ToggleButtonModule = ({ toggleState, setToggleState, logo, title, clicked, isToggled, useFor }) => {
    return (
        <button
            className={`toggleButtonModule ${useFor === title ? 'active-toggle' : 'defaultToggle'}`}
            onClick={clicked}
        >
            {logo}
            <span>{title}</span>
        </button>
    )
}

const UpdateDynamicButton = ({ title, onClick, logo }) => {
    return (
        <button
            title={title}
            className="btn-animated"
            onClick={onClick}
        >
            <div className="btn-content">
                {logo}
                <span>{title}</span>
            </div>
            <div className="btn-ripple"></div>
        </button>
    )
}



export { AddDynamicButton, ToggleButtonModule };